// app/javascript/controllers/question_builder_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'output', 'guidance']

  connect() {
    this.serialize()
  }

  add() {
    const input = document.createElement('div')
    input.classList.add('flex', 'gap-2', 'mt-2')
    input.innerHTML = `
      <input type="text" name="option[]" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600 sm:text-sm" placeholder="Add an option..." />
      <button type="button" data-action="question-builder#remove" class="text-sm text-red-500 hover:underline">Remove</button>
    `
    this.listTarget.appendChild(input)
  }

  remove(event) {
    event.target.closest('div').remove()
    this.serialize()
  }

  serialize() {
    const options = Array.from(
      this.listTarget.querySelectorAll("input[name='option[]']")
    )
      .map((input) => input.value.trim())
      .filter((value) => value.length > 0)

    const guidance = this.hasGuidanceTarget
      ? this.guidanceTarget.value.trim()
      : null

    const config = {
      question_options: options,
      practice_guidance: guidance
    }

    this.outputTarget.value = JSON.stringify(config)
  }

  submit(event) {
    this.serialize()
  }
}
